import {actions} from './actions'
import {mutations} from './mutations'
import {getters} from './getters'
import {Module} from 'vuex'
import {RootState} from '@/store'
import {KeyValuePair} from '@payroll/optimus-common'

export interface SearchState extends BaseState {
    portalTypes: KeyValuePair[],
    userTypes: KeyValuePair[]
}

export const initialState = function (): SearchState {
    return {
        portalTypes: [],
        userTypes: [],
        isEmpty: true
    }
}

export const search: Module<SearchState, RootState> = {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
